import { render, staticRenderFns } from "./selectBtn.vue?vue&type=template&id=31905a81&scoped=true&"
import script from "./selectBtn.vue?vue&type=script&lang=js&"
export * from "./selectBtn.vue?vue&type=script&lang=js&"
import style0 from "./selectBtn.vue?vue&type=style&index=0&id=31905a81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31905a81",
  null
  
)

export default component.exports